<template>
  <div>
    Price at least {{ rule.config.percent }}%
    {{ rule.config.above_below == 'below' ? 'below' : 'above' }} the {{ rule.config.ma_days }}-day
    moving average
  </div>
</template>

<script>
export default {
  props: {
    rule: { type: Object, required: true }
  }
}
</script>
